import React from 'react';
import {
  Alert,
  Box,
  Button,
  Stack,
} from '@mui/material';
import AutoFixHighOutlinedIcon from '@mui/icons-material/AutoFixHighOutlined';

import RecommendationCard from './RecommendationCard';
import { IRecommendationsPanelProps } from './PlanningControlCenter.types';

export default class PlanningRecommendationsPanel extends React.PureComponent<
  IRecommendationsPanelProps
> {
  render(): React.ReactNode {
    const {
      recommendations,
      busy,
      onGenerate,
      onAccept,
      onModify,
      onIgnore,
    } = this.props;

    return (
      <Stack spacing={2}>
        <Box>
          <Button
            variant="contained"
            startIcon={<AutoFixHighOutlinedIcon />}
            disabled={busy}
            onClick={onGenerate}
          >
            Generate Recommendations
          </Button>
        </Box>

        {recommendations.length === 0 ? (
          <Alert severity="info">
            Generate recommendations to prepare the Planning Cycle.
          </Alert>
        ) : (
          recommendations.map((item) => (
            <RecommendationCard
              key={item.rid}
              item={item}
              busy={busy}
              onAccept={onAccept}
              onModify={onModify}
              onIgnore={onIgnore}
            />
          ))
        )}
      </Stack>
    );
  }
}
